<template>
    <div class="na-form">
        <div v-if="topicTypeDetail" class="left">
            <DxTabPanel>
                <DxItem :title="tx.TabBaseData">
                    <div class="dx-fieldset">
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.TtyId }}:</div>
                            <div class="dx-field-value">
                                <DxTextBox :value='topicTypeDetail.TtyId' :readOnly="true" />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.TtyName }}:</div>
                            <div class="dx-field-value">
                                <DxTextBox v-model:value='topicTypeDetail.TtyName' />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.TtyShortName }}:</div>
                            <div class="dx-field-value">
                                <DxTextBox v-model:value='topicTypeDetail.TtyShortName' />
                            </div>

                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.TtyIcon }}:</div>
                            <div class="dx-field-value">
                                <DxTextBox v-model:value='topicTypeDetail.TtyIcon' />
                            </div>

                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.TtyLogoURL }}:</div>
                            <div class="dx-field-value">
                                <DxTextBox v-model:value='topicTypeDetail.TtyLogoURL' :readOnly="true" />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.TtyOrder }}:</div>
                            <div class="dx-field-value">
                                <DxTextBox v-model:value='topicTypeDetail.TtyOrder' />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.TtyEnabled }}:</div>
                            <div class="dx-field-value">
                                <DxCheckBox v-model:value='topicTypeDetail.TtyEnabled' />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.TtyDescription }}:</div>
                            <DxHtmlEditor v-model:value="topicTypeDetail.TtyDescription"
                                          :value-type="editorValueType"
                                          :height="200">
                                <DxToolbar>
                                    <DxItem name="undo" />
                                    <DxItem name="redo" />
                                    <DxItem name="separator" />
                                    <DxItem :accepted-values="sizeValues"
                                            name="size" />
                                    <DxItem :accepted-values="fontValues"
                                            name="font" />
                                    <DxItem name="separator" />
                                    <DxItem name="bold" />
                                    <DxItem name="italic" />
                                    <DxItem name="strike" />
                                    <DxItem name="underline" />
                                    <DxItem name="separator" />
                                    <DxItem name="alignLeft" />
                                    <DxItem name="alignCenter" />
                                    <DxItem name="alignRight" />
                                    <DxItem name="alignJustify" />
                                    <DxItem name="separator" />
                                    <DxItem name="color" />
                                    <DxItem name="background" />
                                </DxToolbar>
                            </DxHtmlEditor>
                        </div>

                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.Workflow }}:</div>
                            <div class="dx-field-value">
                                <DxSelectBox displayExpr="WorName" :dataSource="workflowList" :showClearButton='true' valueExpr="WorId" v-model:value="topicTypeDetail.WorId">
                                </DxSelectBox>
                            </div>
                        </div>

                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.Modultype }}:</div> 
                            <div class="dx-field-value">
                                <DxSelectBox displayExpr="MtyName" :dataSource="modulTypeList" :showClearButton='true' valueExpr="MtyId" v-model:value="topicTypeDetail.MtyId">
                                </DxSelectBox>
                            </div>
                        </div>

                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.RatingTypeGroup }}:</div>
                            <div class="dx-field-value">
                                <DxSelectBox displayExpr="RtgName" :dataSource="ratingTypeGroupList" :showClearButton='true' valueExpr="RtgId" v-model:value="topicTypeDetail.RtgId">
                                </DxSelectBox>
                            </div>
                        </div>

                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.TtyBegin }}:</div>
                            <div class="dx-field-value">
                                <DxDateBox v-model:value='topicTypeDetail.TtyBegin' />
                            </div>

                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.TtyEnd }}:</div>
                            <div class="dx-field-value">
                                <DxDateBox v-model:value='topicTypeDetail.TtyEnd' />
                            </div>

                        </div>


                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.TtyChangedOn }}:</div>
                            <div class="dx-field-value">
                                <DxDateBox :value='topicTypeDetail.TtyChangedOn' :readOnly="true" />
                            </div>

                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.TtyChangedBy }}:</div>
                            <div class="dx-field-value">
                                <DxTextBox :value='topicTypeDetail.TtyChangedBy' :readOnly="true" />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.TtyCreatedOn }}:</div>
                            <div class="dx-field-value">
                                <DxDateBox :value='topicTypeDetail.TtyCreatedOn' :readOnly="true" />
                            </div>

                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.TtyCreatedBy }}:</div>
                            <div class="dx-field-value">
                                <DxTextBox :value='topicTypeDetail.TtyCreatedBy' :readOnly="true" />
                            </div>
                        </div>
                    </div> 
                </DxItem>
                <DxItem :title="tx.TabTopicTypeGroups">
                    <DxDataGrid :data-source="topicTypeGroupList"
                                key-expr="GrpId"
                                :remote-operations="false"
                                :allow-column-reordering="true"
                                :row-alternation-enabled="true"
                                :show-borders="true">
                        <DxEditing :allow-updating="true"
                                   :allow-adding="false"
                                   :allow-deleting="false"
                                   select-text-on-edit-start="true"
                                   start-edit-action="click"
                                   mode="cell" />
                        <DxColumn data-field="GrpName" :caption="col.GrpName" data-type="string" :allowEditing="false" />
                        <DxColumn data-field="TtgCanRead" :caption="col.TtgCanRead" data-type="boolean" :width="120" />
                        <DxColumn data-field="TtgCanEdit" :caption="col.TtgCanEdit" data-type="boolean" :width="120" />
                        <DxColumn data-field="TtgCanCreate" :caption="col.TtgCanCreate" data-type="boolean" :width="120" />
                        <DxColumn data-field="TtgCanDelete" :caption="col.TtgCanDelete" data-type="boolean" :width="120" />
                    </DxDataGrid>

                </DxItem>
                <DxItem title="Formularfelder">
                    <DxDataGrid :data-source="fieldAccess"
                                :key-expr="ObjId"
                                :filter-row-visible="true"
                                :row-alternation-enabled="true"
                                @row-updating="rowUpdating">
                        <DxEditing :allow-updating="true"
                                   :allow-adding="false"
                                   :allow-deleting="false"
                                   mode="cell" />
                        <DxColumn data-field="ObjGroup"
                                  :group-index="0"
                                  :allow-editing="false"
                                  caption="Region"
                                  data-type="string" />
                        <DxColumn data-field="ObjName"
                                  :allow-editing="false"
                                  caption="Caption"
                                  data-type="string" />
                        <DxColumn data-field="ObjAlias"
                                  :allow-editing="false"
                                  caption="Description"
                                  data-type="string" />
                        <DxColumn data-field="CanRead"
                                  caption="Description"
                                  data-type="boolean" />
                        <DxColumn data-field="ObjOrder2"
                                  :visible="false"
                                  :sort-index="0"
                                  caption="Description"
                                  data-type="boolean" />
                        <DxSearchPanel :visible="true" />
                    </DxDataGrid>
                </DxItem>
            </DxTabPanel>
            <div class="na-buttons-row">
                <div>
                    <DxButton :width="120"
                              :text="btn.Save"
                              :type="saveButtonType"
                              :disabled="saveButtonDisabled"
                              styling-mode="contained"
                              @click="onSaveClick($event)" />
                </div>
                <div>
                    <DxButton :width="120"
                              :text="btn.Delete"
                              type="danger"
                              styling-mode="contained"
                              @click="onDeleteClick($event)" />
                </div>

                <div>
                    <DxButton :width="120"
                              :text="btn.Back"
                              type="back"
                              styling-mode="contained"
                              @click="onCancelClick($event)" />
                </div>
            </div>
        </div>
    </div>

</template>

<script> 
    import { DxCheckBox } from 'devextreme-vue/check-box';
    import { DxTextBox } from 'devextreme-vue';
    import { DxButton } from 'devextreme-vue/button';
    import { DxDateBox } from 'devextreme-vue/date-box';
    import { DxTabPanel } from 'devextreme-vue/tab-panel';
    import { DxSelectBox } from 'devextreme-vue/select-box';
    import { DxDataGrid, DxColumn, DxEditing, DxSearchPanel } from 'devextreme-vue/data-grid'; 
    import $ from 'jquery';
    import { DxHtmlEditor, DxToolbar, DxItem } from 'devextreme-vue/html-editor';
    import { confirm } from "devextreme/ui/dialog"

    export default {
        name: 'TopicTypeDetail',
        components: {
            DxButton,
            DxTextBox,
            DxDateBox,
            DxHtmlEditor,
            DxToolbar,
            DxItem,
            DxCheckBox,
            DxTabPanel,
            DxDataGrid,
            DxColumn,
            DxEditing,
            DxSearchPanel,
            DxSelectBox
        },
        data() {

            return {
                tx: {
                    TabBaseData: this.$LanguageProvider.GetResource("TabBaseData", "Caption", "Basisdaten"),
                    TabTopicTypeGroups: this.$LanguageProvider.GetResource("TabTopicTypeGroups", "Caption", "Gruppen-Berechtigungen"),
                    TtyId: this.$LanguageProvider.GetResource("TtyId", "Caption", "ID"),
                    TtyName: this.$LanguageProvider.GetResource("TtyName", "Caption", "Name"),
                    TtyIcon: this.$LanguageProvider.GetResource("TtyIcon", "Caption", "Symbol"),
                    TtyShortName: this.$LanguageProvider.GetResource("TtyShortName", "Caption", "Kurzname"),
                    TtyLogoURL: this.$LanguageProvider.GetResource("TtyLogoURL", "Caption", "Logo Datei"),
                    TtyOrder: this.$LanguageProvider.GetResource("TtyOrder", "Caption", "Position"),
                    TtyBegin: this.$LanguageProvider.GetResource("TtyBegin", "Caption", "Beginn"),
                    TtyEnd: this.$LanguageProvider.GetResource("TtyEnd", "Caption", "Ende "),
                    TtyEnabled: this.$LanguageProvider.GetResource("TtyEnabled", "Caption", "Aktiviert"),
                    TtyDescription: this.$LanguageProvider.GetResource("TtyDescription", "Caption", "Beschreibung"),
                    TtyChangedOn: this.$LanguageProvider.GetResource("TtyChangedOn", "Caption", "Geändert am"),
                    TtyChangedBy: this.$LanguageProvider.GetResource("TtyChangedBy", "Caption", "Geändert von"),
                    TtyCreatedOn: this.$LanguageProvider.GetResource("TtyCreatedOn", "Caption", "Erstellt am"),
                    TtyCreatedBy: this.$LanguageProvider.GetResource("TtyCreatedBy", "Caption", "Erstellt von"),
                    Workflow: this.$LanguageProvider.GetResource("Workflow", "Caption", "Workflow"),
                    Modultype: this.$LanguageProvider.GetResource("Modultype", "Caption", "Modultyp"),
                    RatingTypeGroup: this.$LanguageProvider.GetResource("RatingTypeGroup", "Caption", "Öffentliche Bewertungsrunde")
                },
                col: {
                    GrpName: this.$LanguageProvider.GetResource("GrpName", "Caption", "Rolle"),
                    TtgCanRead: this.$LanguageProvider.GetResource("TtgCanRead", "Column", "Lesen"),
                    TtgCanEdit: this.$LanguageProvider.GetResource("TtgCanEdit", "Caption", "Bearbeiten"),
                    TtgCanCreate: this.$LanguageProvider.GetResource("TtgCanCreate", "Column", "Erstellen"),
                    TtgCanDelete: this.$LanguageProvider.GetResource("TtgCanDelete", "Caption", "Löschen"),
                },
                btn: {
                    Save: this.$LanguageProvider.GetResource("Save", "Button", "Speichern"),
                    Delete: this.$LanguageProvider.GetResource("Delete", "Button", "Löschen"),
                    Back: this.$LanguageProvider.GetResource("Back", "Button", "Zurück"),
                },
                dlg: {
                    DeleteConfirmationText: this.$LanguageProvider.GetResource("DeleteConfirmation", "Text", "Sind Sie sicher, dass Sie den TopicType löschen möchten?"),
                    DeleteConfirmationTitle: this.$LanguageProvider.GetResource("DeleteConfirmation", "Title", "Löschen bestätigen"),
                }
            };
        },
        props: {
            ttyId: {
                type: [Number],
                required: true,
                default: 0
            },
        },
        computed: {
            topicTypeDetail() {
                return this.$store.state.topicTypeStore.topicTypeDetail
            },
            modulTypeList() {
                return this.$store.state.modulTypeStore.modulTypeList
            },
            ratingTypeGroupList() {
                return this.$store.state.ratingTypeGroupStore.ratingTypeGroupFullSimpleList
            },
            workflowList() {
                return this.$store.state.workflowStore.workflowList
            },
            topicTypeDetailText() {
                return JSON.stringify(this.$store.state.topicTypeStore.topicTypeDetail)
            },
            topicTypeGroupList() {
                return this.$store.state.topicTypeStore.topicTypeGroupList
            },
            topicTypeGroupListText() {
                return JSON.stringify(this.$store.state.topicTypeStore.topicTypeGroupList)
            }, 
            saveButtonType() {
                return this.$store.state.topicTypeStore.topicTypeDetailChanged 
                    || this.$store.state.topicTypeStore.topicTypeGroupListChanged 
                    ? "success" : "normal"
            },
            saveButtonDisabled() {
                return this.$store.state.topicTypeStore.topicTypeDetailChanged
                    || this.$store.state.topicTypeStore.topicTypeGroupListChanged
                    ? false : true
            },
        },
        created: function () {

        },
        watch: {
            topicTypeDetailText: function (newVal, oldVal) {
                if (oldVal != "{}") {
                    this.$store.state.topicTypeStore.topicTypeDetailChanged = true
                }
            },
            topicTypeGroupListText: function (newVal, oldVal) {
                if (oldVal != "[]") {
                    this.$store.state.topicTypeStore.topicTypeGroupListChanged = true
                }
            },
        },
        mounted: function () {
            let vm = this
            this.$store.dispatch("getTopicTypeGroupList", { ttyId: vm.ttyId })
            this.$store.dispatch("getTopicTypeDetail", { ttyId: vm.ttyId })
            this.$store.dispatch("getModulTypeList")
            this.$store.dispatch("getWorkflowList")
            this.$store.dispatch("getRatingTypeGroupFullSimpleList")
        },
        methods: {
            onCancelClick() {
                $("form").attr("action", window.location.pathname + "?action=cancel").submit();
            },
            onSaveClick() {
                this.$store.dispatch("saveTopicTypeDetail") 
                this.$store.dispatch("saveTopicTypeGroupList")
            },
            onDeleteClick() {
                let result = confirm( this.dlg.DeleteConfirmationText, this.dlg.DeleteConfirmationTitle);
                result.then((dialogResult) => {
                    if (dialogResult) {
                        $("form").attr("action", window.location.pathname + "?action=delete&ttyId=" + this.ttyId).submit(); 
                    }
                });
            }, 
        }
    }


</script>
<style>
</style>
